import { api } from '@/api';

export type MessageFeedbackExportResponse = Blob;

const messageFeedbackExportApi = api.injectEndpoints({
  endpoints: (builder) => ({
    getMessageFeedbackExport: builder.query<MessageFeedbackExportResponse, void>({
      query: () => ({
        url: `debug/message-feedback-export`,
        method: 'GET',
        headers: {
          'debug-api-key': import.meta.env.VITE_DEBUG_API_KEY || '',
        },
        responseHandler: async (response) => {
          return await response.blob();
        },
        cache: 'no-cache',
      }),
      extraOptions: { maxRetries: 0 },
    }),
  }),
});

export const { useLazyGetMessageFeedbackExportQuery } = messageFeedbackExportApi;
